import { render, staticRenderFns } from "./CrowdxAboutSection.vue?vue&type=template&id=7ab02e03&scoped=true"
import script from "./CrowdxAboutSection.vue?vue&type=script&lang=js"
export * from "./CrowdxAboutSection.vue?vue&type=script&lang=js"
import style0 from "./CrowdxAboutSection.vue?vue&type=style&index=0&id=7ab02e03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab02e03",
  null
  
)

export default component.exports